// @ts-nocheck
import Zone from "@insite/client-framework/Components/Zone";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { baseGridHiddenProps, baseGridProps } from "@store/Themes/common/props/baseGrid";
import useExpandProps, { ExpandStyles } from "@toolkit/Framework/Common/Hooks/useExpandProps";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
import React, { FC, useMemo } from "react";

export interface SideColumnLayoutProps extends ExpandStyles<SideColumnLayoutStyles> {
    id: string;
    showSideColumnOnMobile?: boolean;
}

export interface SideColumnLayoutStyles {
    container?: GridContainerProps;
    leftColumn?: GridItemProps;
    rightColumn?: GridItemProps;
}

export const sideColumnLayoutStyles: SideColumnLayoutStyles = {};

const SideColumnLayout: FC<SideColumnLayoutProps> = ({
    id,
    extendedStyles,
    overridedStyles,
    showSideColumnOnMobile,
}) => {
    const baseStyles = useMemo(() => {
        const gridProps = showSideColumnOnMobile ? baseGridProps : baseGridHiddenProps;
        return mergeProps<SideColumnLayoutStyles>(sideColumnLayoutStyles, {
            container: gridProps.container,
            leftColumn: gridProps.sideColumn,
            rightColumn: gridProps.mainColumn,
        });
    }, [sideColumnLayoutStyles, showSideColumnOnMobile]);
    const styles = useExpandProps(baseStyles, extendedStyles, overridedStyles);

    return (
        <GridContainer {...styles.container}>
            <GridItem {...styles.leftColumn}>
                <Zone contentId={id} zoneName="Side" />
            </GridItem>
            <GridItem {...styles.rightColumn}>
                <Zone contentId={id} zoneName="Content" />
            </GridItem>
        </GridContainer>
    );
};

export default SideColumnLayout;
